import { createContext, useContext, useState, useEffect } from 'react';
import { createLogger } from '../utils/logger';

const logger = createLogger({ module: 'GoogleAuthContext' });

interface GoogleAuthContextType {
  isConnected: boolean;
  connect: () => Promise<void>;
  disconnect: () => Promise<void>;
  isConfigured: boolean;
}

const GoogleAuthContext = createContext<GoogleAuthContextType | undefined>(undefined);

export const useGoogleAuth = () => {
  const context = useContext(GoogleAuthContext);
  if (!context) {
    throw new Error('useGoogleAuth must be used within a GoogleAuthProvider');
  }
  return context;
};

export const GoogleAuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  // Always set Google integration as disabled
  const isConfigured = false;
  const isConnected = false;

  useEffect(() => {
    logger.debug('Google Drive integration is disabled');
  }, []);

  // No-op functions
  const connect = async () => {
    logger.error('Google authentication is disabled');
    throw new Error('Google authentication is disabled');
  };

  const disconnect = async () => {
    logger.error('Google authentication is disabled');
    throw new Error('Google authentication is disabled');
  };

  return (
    <GoogleAuthContext.Provider value={{ 
      isConnected: false, 
      connect,
      disconnect,
      isConfigured: false
    }}>
      {children}
    </GoogleAuthContext.Provider>
  );
}; 